module.exports = __webpack_public_path__ + "media/images/systemreach_introduction-198a4f0539a74d42f1fa95b404604fa8.png";